var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/static/new/img/login/login_logo.webp"),"alt":""}}),_c('div',{staticClass:"solid"}),_c('div',{staticClass:"text"},[_vm._v("直播行业法律服务平台")])])])
}]

export { render, staticRenderFns }